import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { config } from '../config/env.config';
import { TokenResponse } from '../types/api';
import StorageService from '../services/StorageService';

const AUTH_API = config.api.auth;

export const useTokenValidation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Salta validazione per rotte pubbliche
    const publicRoutes = ['/login', '/redirect'];
    if (publicRoutes.includes(location.pathname)) {
      return;
    }

    // Verifica presenza token
    const token = StorageService.getToken();
    if (!token) {
      navigate('/login');
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        // Valida token corrente
        const resp = await axios.get(`${AUTH_API}/authorization`, {
          headers: { 'pwc-identity-token': token }
        });

        if (!cancelled && resp.status !== 200) {
          throw new Error('Invalid token');
        }
      } catch (error) {
        if (cancelled) return;

        // Tentativo di refresh se token scaduto (498)
        if (axios.isAxiosError(error) && error.response?.status === 498) {
          const refreshToken = StorageService.getRefreshToken();

          if (refreshToken) {
            try {
              const refreshResp = await axios.get<TokenResponse>(
                `${AUTH_API}/refresh-token`,
                { headers: { 'pwc-identity-refresh-token': refreshToken } }
              );

              if (refreshResp.data?.access_token) {
                StorageService.setToken(refreshResp.data.access_token);
                if (refreshResp.data.refresh_token) {
                  StorageService.setRefreshToken(refreshResp.data.refresh_token);
                }
                return;
              }
            } catch {
              // Refresh fallito, procedi con logout
            }
          }
        }

        // Logout: pulisci storage e redirect a login
        StorageService.clearAll();
        navigate('/login');
      }
    })();

    return () => { cancelled = true; };
  }, [navigate]);
};
